import React, {useEffect, useState} from "react";
import ActionPopover from "../../../common/popovers/ActionPopover";
import SimpleTable from "../../../common/tables/SimpleTable";
import {useDispatch, useSelector} from "react-redux";
import {
    savePublicDomain,
    loadPublicDomains,
    deletePublicDomain, makePublicDomainDefault
} from "../../../../actions/partnerDomainsActions";
import partnerDomainsReducer from "../../../../store/reducers/partnerDomainsReducer";

export default function DomainsContent({}) {

    const dispatch = useDispatch();
    const domains = useSelector(state => state.partnerDomainsReducer.domains);
    const [sortableColumn, setSortableColumn] = useState(null);
    const [sortableDirection, setSortableDirection] = useState(null);


    useEffect(() => {
        dispatch(loadPublicDomains());
    }, []);

    const addDomain = (data) => {
        const domain = data?.inputValue;
        dispatch(savePublicDomain(domain, () => dispatch(loadPublicDomains())));
    };

    const deleteDomain = (item) => {
        dispatch(deletePublicDomain(item, () => dispatch(loadPublicDomains())))
    };

    const makeDefault = (item) => {
        dispatch(makePublicDomainDefault(item, () => dispatch(loadPublicDomains())))
    };

    const setSorting = (column, direction) => {
        setSortableColumn(column);
        setSortableDirection(direction);
    };

    const tableColumns = () => {
        return [
            {
                name: "Домен",
                key: "domain",
                getBodyCellValue: item => item["cname"],
                headerCellStyle: {minWidth: "150px"},
                bodyCellStyle: {textAlign: "center"},
            },
            {
                name: "Дата добавления",
                key: "createDate",
                getBodyCellValue: item => item["createDate"],
                headerCellStyle: {minWidth: "150px"},
                bodyCellStyle: {textAlign: "center"},
            },
            {
                name: "Дата проверки",
                key: "lastCheckDate",
                getBodyCellValue: item => item["lastCheckDate"] ? item["lastCheckDate"] : "",
                headerCellStyle: {minWidth: "150px"},
                bodyCellStyle: {textAlign: "center"},
            },
            {
                name: "Дата окончания регистрации",
                key: "registrationExpirationDate",
                getBodyCellValue: item => item["registrationExpirationDate"] ? item["registrationExpirationDate"] : "-",
                headerCellStyle: {minWidth: "150px"},
                bodyCellStyle: {textAlign: "center"},
            },
            {
                name: "Статус",
                key: "status",
                getBodyCellValue: item => item["status"],
                headerCellStyle: {minWidth: "100px"},
                bodyCellStyle: {textAlign: "center"},
            },
            {
                name: <ActionPopover
                    button={<i className="ti ti-plus td-save"/>}
                    tooltip="Добавить домен"
                    popoverLocation='right'
                    label="Новый домен"
                    hasInput
                    handleSubmit={(data) => {addDomain(data)}}/>,
                key: "actions",
                getBodyCellValue: (item) =>
                    <div style={{display: "flex"}}>
                        <ActionPopover
                            button={<i className={item.defaultDomain ? "fa fa-star" : "fa fa-star-o  td-save"} style={{fontSize: "20px"}}/>}
                            tooltip={item.defaultDomain ? "Дефолтный домен" : "Сделать дефолтнным"}
                            popoverLocation='right'
                            label="Сделать дефолтнным?"
                            handleSubmit={() => !item.defaultDomain && makeDefault(item)}/>
                        <ActionPopover
                        button={<i className="ti ti-trash td-save"/>}
                        tooltip="Удалить"
                        popoverLocation='right'
                        label="Удалить?"
                        handleSubmit={() => deleteDomain(item)}/>
                        </div>,
                headerCellStyle: {minWidth: "80px", width: "80px", textAlign: "right"},
                bodyCellStyle: {textAlign: "right"},
                isSortingDisabled: true,
            },
        ]
    };


    return <div className="responsive-block statistic_table_wrapper" id="fullWidth" onScroll={() =>{}} style={{minHeight: '75vh'}}>
        <SimpleTable tableClassName="table table-bordered nowrap sticky-header sticky-action sticky-footer userselecttext"
                     columns={tableColumns()} data={domains} bodyRowKey="id" isSortable sortableColumn={sortableColumn} sortableDirection={sortableDirection} onSort={setSorting}/>
    </div>;
}